import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { TextField } from '@mui/material';
import black_logo from '../images/black_logo.png';
import gvLogo from '../images/gvLogo.png';

import '../css/jb-styles.css';
import AppHeader from './AppHeader';

import { useDispatch, useSelector } from 'react-redux';

import {
  firstName,
  lastName,
  mobileNumber,
  emailAddress,
  password,
  confirmPassword,
  passwordsMatch,
} from '../../redux/registrationSlice';

const textStyle = {
  width: '100%',
  "& .MuiFilledInput-root": {
    backgroundColor: '#FFFFFF',
    color: '#3B4E68',
    "&:after": {
      borderColor: "#FFFFFF",
      backgroundColor: '#FFFFFF',
    },
  },
  "& .MuiInputLabel-filled": {
    color: '#3B4E68',
    "&.Mui-focused": {
      color: '#3B4E68',
    },
  },
  '& .Mui-focused:hover': {
    borderColor: "#FFFFFF",
    backgroundColor: '#FFFFFF',
  },
  "&:hover:not(.Mui-focused)": {
    borderColor: "#FFFFFF",
    backgroundColor: '#FFFFFF',
  },
  "& .Mui-focused:not(:hover)": {
    borderColor: "#FFFFFF",
    backgroundColor: '#FFFFFF',
  }
};

export default function Register() {
  const theme = useTheme();

  const dispatch = useDispatch();

  const passwordsMatchState = useSelector((state) => state.registration.passwordsMatch);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    switch (name) {
      case 'firstName':
        dispatch(firstName(value));
        break;
      case 'lastName':
        dispatch(lastName(value));
        break;
      case 'mobileNumber':
        dispatch(mobileNumber(value));
        break;
      case 'emailAddress':
        dispatch(emailAddress(value));
        break;
      case 'password':
        dispatch(password(value));
        dispatch(passwordsMatch());
        break;
      case 'confirmPassword':
        dispatch(confirmPassword(value));
        dispatch(passwordsMatch());
        break;
      default:

    }

  };

  return (
    <React.Fragment>

      <Box
        sx={{
          height: '100%',
          width: '100%',
          backgroundColor: '#3B4E68',
          display: 'flex',
          flexDirection: 'column',
          // justifyContent: 'space-between',
          paddingBottom: '20px',
        }}
      >

        <Box
        >
          <img
            // src={black_logo}
            src={gvLogo}
            alt="gridvault logo"
            className='home-icon'
            style={{
              width: '100%'
            }}
          />
        </Box>

        {/* <Box>
          <AppHeader />
        </Box> */}

        <Box
          sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            paddingBottom: '20px',
            paddingLeft: '20px',
            paddingRight: '20px',
          }}
        >


          <Box>
            <Typography
              variant='body1'
              sx={{
                color: '#3B4E68',
                fontSize: '24px',
                fontWeight: 'bold',
                textAlign: 'left',
                paddingBottom: '20px'
              }}
            >
              Register Application
            </Typography>
          </Box>


          <Box
            sx={{
              paddingBottom: '10px',
              width: '100%',
            }}
          >
            <TextField
              label="First name"
              variant="filled"
              name='firstName'
              sx={textStyle}
              onChange={handleChange}
            />
          </Box>

          <Box
            sx={{
              paddingBottom: '10px',
              width: '100%',
            }}
          >
            <TextField
              label="Last name"
              variant="filled"
              name="lastName"
              sx={textStyle}
              onChange={handleChange}
            />
          </Box>

          <Box
            sx={{
              paddingBottom: '10px',
              width: '100%',
            }}
          >
            <TextField
              label="email address"
              variant="filled"
              name="emailAddress"
              sx={textStyle}
              onChange={handleChange}
            />
          </Box>

          <Box
            sx={{
              paddingBottom: '10px',
              width: '100%',
            }}
          >
            <TextField
              label="Mobile phone"
              variant="filled"
              name="mobileNumber"
              sx={textStyle}
              onChange={handleChange}
            />
          </Box>

          <Box
            sx={{
              paddingBottom: '10px',
              width: '100%',
            }}
          >
            <TextField
              label="Password"
              variant="filled"
              name="password"
              sx={textStyle}
              onChange={handleChange}
            />
          </Box>

          <Box
            sx={{
              paddingBottom: '10px',
              width: '100%',
            }}
          >
            <TextField
              label="Confirm password"
              variant="filled"
              name="confirmPassword"
              sx={textStyle}
              onChange={handleChange}
            />
          </Box>

          {/* <Box
            sx={{
              color: 'white'
            }}
          >
            Match? - {passwordsMatchState}
          </Box> */}

          <Box
            sx={{
              paddingTop: '20px',
            }}
          >
            <Link to='/register-pattern' >
              <Button
                sx={{
                  backgroundColor: '#3c82f6',
                  border: '1px solid #3B4E68',
                  color: '#FFFFFF',
                  width: '90%',
                  '&:hover': {
                    border: '1px solid #FFFFFF',
                    color: '#FFFFFF',
                  }
                }}
              >
                Create Account
              </Button>
            </Link>
          </Box>

        </Box>
      </Box>

    </React.Fragment >
  );
}